import createPromise from "helpers/createPromise";
import TCFdeleteLocalTCString from "../TCFdeleteLocalTCString";
import { IBulkConfig } from "types/config-files/mainConfig";

// TODO: HANDLE BULK CONSENT
const deleteTCFConsent = (bulkConfig: IBulkConfig) => {
  return createPromise<void>(() => {
    TCFdeleteLocalTCString(bulkConfig);
  });
};

export default deleteTCFConsent;
